import React from 'react'
import { Box, Typography } from '@mui/material'
import ReactFilter from '../../../../components/inputs/ReactFilterList'
import ProcessedReactFilter from '../../../../components/inputs/ProcessedReactFilter'
import GoogleIcon from '../../../../icon/GoogleIcon'

import SearchInput from '../../../../components/SearchInput'
import {
  hasAnyActiveFilter,
  hasAvailableFilters
} from '../../helpers/filterUtils'

const OcFiltersBar = ({
  filters,
  filterVersion,
  onFilterChange,
  onProcessedApply,
  searchInput,
  onSearchChange,
  onSearchEnter,
  onReset,
  onClearSearch,
  allSelectedOptions,
  processedFilter
}) => {

  const shouldShowReset = hasAnyActiveFilter({
    allSelectedOptions,
    processedFilter,
    searchInput
  })

  const areMainFiltersAvailable = hasAvailableFilters(filters)


  return (
    <>
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        Filtrar órdenes de compra por:
      </Typography>

      <Box
        display="flex"
        alignItems="flex-start"
        justifyContent="space-between"
        gap={1}
        mb={3}
      >
        <Box
          display="flex"
          flexWrap="wrap"
          gap={1}
          alignItems="center"
          flex={1}
        >
          <GoogleIcon
            className="filter-icon-poc oc-icon-primary"
            name="page_info"
            size={22}
          />

          {filters.map((filter, indx) => (
            <ReactFilter
              key={filter.key}
              title={filter.key}
              identifier={filter.key}
              options={filter.value}
              resetWatcher={filterVersion}
              onSelectionChange={onFilterChange}
              disabled={!filter.value || filter.value.length === 0}
            />
          ))}

          <ProcessedReactFilter
            resetWatcher={filterVersion}
            onApply={onProcessedApply}
            disabled={!areMainFiltersAvailable}
          />
        </Box>

        <Box flexShrink={0} mt={0.6}>
          <SearchInput
            value={searchInput}
            onChange={onSearchChange}
            onEnter={onSearchEnter}
            onClear={onClearSearch}
            placeholder="Buscar órdenes por cliente , sucursal o # OC"
          />
        </Box>
      </Box>

      {shouldShowReset && (
        <Typography
          variant="body2"
          className="oc-reset-filter"
          onClick={onReset}
        >
          Restablecer filtros aplicados
        </Typography>
      )}
    </>
  )
}

export default OcFiltersBar
